import { Flex, Link, Text } from "@chakra-ui/react";
import { DashboardChargeList } from "./charge-list";
import { useEffect, useState } from "react";
import { ChargeMetrics, DashboardChargeData } from "@/models";
import { Select } from "@/components";

interface DashboardChargeListProps {
  charges: Array<DashboardChargeData>;
  chargeMetrics: ChargeMetrics;
}

export function DashboardCharge({
  charges,
}: DashboardChargeListProps) {
  const [chargesFiltered, setChargesFiltered] =
    useState<Array<DashboardChargeData>>(charges);
  const [chargeListFilter, setChargeListFilter] = useState("ALL");

  function handleFilterChargesArray() {
    setChargesFiltered(
      charges.filter((charge) => {
        if (chargeListFilter === "ALL") return charge;
        else return charge.status === chargeListFilter;
      })
    );
  }

  useEffect(() => {
    handleFilterChargesArray();
  }, [chargeListFilter, charges]);

  return (
    <Flex w="100%" h="100%" flexDir="column" >
      <Flex h="10%" w="100%" p="0 1rem" align="center" justify="space-between">
        <Flex>
          <Text marginRight="1rem">Recebíveis</Text>
          <Link href="/cobrancas" textDecoration="underline">
            ver todos
          </Link>
        </Flex>
        <Select
          name="chargeFilter"
          label=""
          w="35%"
          mt="4px"
          optionsList={[
            { title: "Todas", value: "ALL" },
            { title: "Pagas", value: "PAID" },
            { title: "Atrasadas", value: "LATE" },
          ]}
          defaultValue="ALL"
          onChange={(e) => setChargeListFilter(e.target.value)}
          data-testid="dash-test-select-charge-filter"
        />
      </Flex>
      <Flex h="100%" w="100%" overflowY="scroll">
        {chargesFiltered && <DashboardChargeList charges={chargesFiltered} />}
      </Flex>
    </Flex>
  );
}
